export default __webpack_public_path__ + "static/media/MarkPro-Light.4a98043c.eot";